import { FormHelperText, TextField } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import RadioCustom from 'commons/RadioCustom';
import Text from 'commons/Text';
import Colors from 'configs/Colors';
import { ConfirmationOptions } from 'configs/Constant';

import useStyles from './styles';

const ConfirmationOption = ({
  selectedConfirmnOption,
  piece,
  onSelectSection,
  setValue,
  canEditArtwork = true,
  error,
  helperText,
  has_certificate,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleChangeSection = (e) => {
    const intValue = parseInt(e.target.value, 10);

    if (e.target.value === '' || !Number.isInteger(intValue)) {
      setValue('piece', '');
    } else {
      setValue('piece', intValue);
    }
  };

  return (
    <div style={{ marginBottom: -10 }}>
      <Text
        type="sm"
        mb={-5}
        mt={24}
      >
        {t('does_artwork_have_more_than_one_section')}

        <Text
          variant="span"
          type={'sm'}
          color={Colors.Red6}
          ml={6}
          fontWeightBold
        >
          *
        </Text>
      </Text>
      <div className={classes.confirmationOptions}>
        {ConfirmationOptions.map((item, index) => (
          <RadioCustom
            item={item}
            key={index}
            keyLabel={item.id}
            value={t(item.name)}
            selectedOption={selectedConfirmnOption}
            onOptionChange={() => onSelectSection(item)}
            disabled={!canEditArtwork || has_certificate}
          />
        ))}
      </div>
      {selectedConfirmnOption?.id === 1 && (
        <div className={classes.wrapTextInputTotalSection}>
          <Text
            type="sm"
            mb={0}
            mt={-5}
          >
            {t('total_sections')}
          </Text>
          <TextField
            value={piece}
            onChange={handleChangeSection}
            fullWidth
            size="small"
            placeholder={t('please_input_total_sections')}
            className={clsx({
              [classes.disabled]: !canEditArtwork || has_certificate,
            })}
            disabled={!canEditArtwork || has_certificate}
          />
        </div>
      )}

      {error && (
        <FormHelperText
          className={classes.helperText}
          error
        >
          {helperText}
        </FormHelperText>
      )}
    </div>
  );
};

export default ConfirmationOption;
